import * as React from 'react';

import styled from 'styled-components';

import Typography from '../typography';
import { motion, AnimatePresence } from 'framer-motion';
import Tooltip from '@components/basics/tooltip';
import { AvatarImage } from '@components/basics/avatar/avatar-image';

export interface AvatarProps {
  className?: string;
  alt?: any;
  src?: any;
  size?: string;
  title?: string;
  more?: number;
  border?: boolean;
  name?: string;
  onClick?: () => void;
  isTooltipEnabled?: boolean;
}

export const Avatar: React.FC<AvatarProps> = (props) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <AvatarWrapper
      className={`${props.className} ${props.border ? ' bordered' : ''}`}
      title={props.title}
      onClick={props.onClick}
    >
      {props.isTooltipEnabled ? (
        <motion.div
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <AvatarImage
            more={props.more}
            name={props.name}
            alt={props.alt}
            src={props.src}
            size={props.size}
          />
          {isHover && props.alt ? (
            <AnimatePresence>
              <Tooltip
                className="hide-mobile"
                top="80%"
                hasShadow
                right="-100%"
                isOpen={isHover}
              >
                <Typography weight="700">{props.alt}</Typography>
              </Tooltip>
            </AnimatePresence>
          ) : null}
        </motion.div>
      ) : (
        <AvatarImage
          more={props.more}
          name={props.name}
          alt={props.alt}
          src={props.src}
          size={props.size}
        />
      )}
    </AvatarWrapper>
  );
};

export default styled(Avatar)`
  width: ${(props) => (props.size ? props.size : '32')}px;
  height: ${(props) => (props.size ? props.size : '32')}px;

  .name {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.secondaryHover};

    span {
      margin: 0 auto;
      color: ${({ theme }) => theme.colors.black};
    }
  }

  .text-avatar {
    font-size: ${({ theme }) => theme.typography.small};
  }
`;

const AvatarWrapper = styled.div<{ size?: string }>`
  position: relative;
`;
